/* "Video with Heading" section behaviour.
   Click-to-play poster facade: no player JS (YouTube/Vimeo iframe or a pasted
   embed such as Wistia) is loaded until the visitor clicks the thumbnail.

   Liquid-free on purpose - every value it needs comes from data attributes on
   the poster button, and scoping is done against the poster's own wrapper
   instead of a section-id selector, so one file serves every instance. */
(function () {
  var POSTER = '.video-heading-section__poster';
  var WRAPPER = '.video-heading-section__video-wrapper';
  var TEMPLATE = '.video-heading-section__embed-template';

  function autoplayParam(src) {
    return src.indexOf('wistia') !== -1 ? 'autoPlay=true' : 'autoplay=1';
  }

  function playEmbed(poster) {
    // The template sits next to the poster in the same wrapper, so scope there
    // rather than to the section - keeps sibling instances independent.
    var wrapper = poster.closest(WRAPPER);
    var template = wrapper && wrapper.querySelector(TEMPLATE);
    if (!template) return;

    var holder = document.createElement('div');
    holder.className = 'video-heading-section__embed';
    holder.innerHTML = template.innerHTML;

    // Tell the embedded player to start on its own, since it was inserted by a click.
    Array.prototype.forEach.call(holder.querySelectorAll('wistia-player'), function (player) {
      player.setAttribute('autoplay', 'true');
    });
    Array.prototype.forEach.call(holder.querySelectorAll('.wistia_embed'), function (embed) {
      if (embed.className.indexOf('autoPlay=true') === -1) embed.className += ' autoPlay=true';
    });
    Array.prototype.forEach.call(holder.querySelectorAll('iframe[src]'), function (frame) {
      var src = frame.getAttribute('src');
      frame.setAttribute('src', src + (src.indexOf('?') === -1 ? '?' : '&') + autoplayParam(src));
    });

    // Scripts set via innerHTML never run — recreate them so the player loads.
    Array.prototype.forEach.call(holder.querySelectorAll('script'), function (oldScript) {
      var script = document.createElement('script');
      Array.prototype.forEach.call(oldScript.attributes, function (attr) {
        script.setAttribute(attr.name, attr.value);
      });
      script.textContent = oldScript.textContent;
      oldScript.parentNode.replaceChild(script, oldScript);
    });

    poster.replaceWith(holder);
    template.remove();

    // Fallback for players that ignore the autoplay attribute set before definition.
    if (window.customElements && holder.querySelector('wistia-player')) {
      window.customElements.whenDefined('wistia-player').then(function () {
        var player = holder.querySelector('wistia-player');
        if (player && typeof player.play === 'function') player.play();
      });
    }
  }

  function playPlatformVideo(poster) {
    var src = poster.getAttribute('data-video-src');
    if (!src) return;
    src += (src.indexOf('?') === -1 ? '?' : '&') + 'autoplay=1';
    var iframe = document.createElement('iframe');
    iframe.setAttribute('src', src);
    iframe.setAttribute('allow', poster.getAttribute('data-video-allow') || '');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('title', poster.getAttribute('data-video-title') || '');
    poster.replaceWith(iframe);
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(POSTER).forEach(function (poster) {
      if (poster.dataset.videoHeadingBound) return; // section can be loaded twice
      poster.dataset.videoHeadingBound = 'true';
      poster.addEventListener('click', function () {
        if (poster.hasAttribute('data-video-embed')) playEmbed(poster);
        else playPlatformVideo(poster);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  // Re-bind after a theme-editor section re-render.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
